import React from 'react';
import { Search } from 'lucide-react';

export default function AdvancedSearch({ filters, setFilters }){
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Search</label>
          <div className="relative">
            <Search className="absolute left-3 top-3 text-gray-400" size={20} />
            <input
              type="text"
              placeholder="Job title, company..."
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-medium focus:border-transparent outline-none"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
          <select
            value={filters.category}
            onChange={(e) => setFilters({ ...filters, category: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-medium focus:border-transparent outline-none"
          >
            <option value="">All Categories</option>
            <option value="IT">IT & Technology</option>
            <option value="Finance">Finance</option>
            <option value="HR">Human Resources</option>
            <option value="Sales">Sales & Marketing</option>
            <option value="Healthcare">Healthcare</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Location</label>
          <input
            type="text"
            placeholder="City, Country"
            value={filters.location}
            onChange={(e) => setFilters({ ...filters, location: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-medium focus:border-transparent outline-none"
          />
        </div>

        <div className="flex items-end">
          <button
            onClick={() => setFilters({ search: '', category: '', location: '' })}
            className="w-full bg-secondary-verylight text-gray-800 py-2 rounded-lg hover:bg-secondary-light transition font-medium"
          >
            Clear Filters
          </button>
        </div>
      </div>
    </div>
  );
}
